import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  // rows: [{ _id, categoryId, productId, product: { _id, title, price, image, ... } }]
  defaults: [],
};

const slice = createSlice({
  name: 'defaultCategoryProduct',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getDefaultsSuccess(state, action) {
      state.isLoading = false;
      state.defaults = action.payload || [];
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

// GET /api/v2/default-products  -> all category defaults (product hydrated)
export function getDefaultCategoryProducts() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/v2/default-products');
      dispatch(slice.actions.getDefaultsSuccess(response.data?.data || []));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// POST /api/v2/default-products  body: { categoryId, productId }
export function setDefaultCategoryProduct(categoryId, productId) {
  return async () => {
    try {
      await axios.post('/api/v2/default-products', { categoryId, productId });
      dispatch(getDefaultCategoryProducts());
      return { payload: {} };
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      const message =
        error?.message || error?.response?.data?.message || 'Failed to set default product';
      return { payload: { error: message } };
    }
  };
}

// DELETE /api/v2/default-products/:categoryId
export function removeDefaultCategoryProduct(categoryId) {
  return async () => {
    try {
      await axios.delete(`/api/v2/default-products/${categoryId}`);
      dispatch(getDefaultCategoryProducts());
      return { payload: {} };
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      const message =
        error?.message || error?.response?.data?.message || 'Failed to remove default product';
      return { payload: { error: message } };
    }
  };
}

// Product search scoped to a single category (for the per-category dropdown).
// Uses the lightweight ProductV endpoint (no image/S3 hydration, no joins) so
// the dropdown stays fast. Returns an array so each box owns its options locally.
export function searchProductsByCategory(categoryId, keyword) {
  return async () => {
    try {
      const response = await axios.get('/api/productV/lite', {
        params: { categoryId, keyword: keyword || undefined, limit: 25 },
      });
      return response.data?.products || [];
    } catch (error) {
      return [];
    }
  };
}
